module.exports = __webpack_public_path__ + "img/leix.ce935345.png";